import { useState, useEffect } from "react";

const API = "https://americanherdcattleco.com";
const ADMIN_PASS = "herd2025";
const TRUSTED_IPS = ["99.103.219.83"];

const STATE_NAMES = {"AL":"Alabama","AK":"Alaska","AZ":"Arizona","AR":"Arkansas","CA":"California","CO":"Colorado","CT":"Connecticut","DE":"Delaware","FL":"Florida","GA":"Georgia","HI":"Hawaii","ID":"Idaho","IL":"Illinois","IN":"Indiana","IA":"Iowa","KS":"Kansas","KY":"Kentucky","LA":"Louisiana","ME":"Maine","MD":"Maryland","MA":"Massachusetts","MI":"Michigan","MN":"Minnesota","MS":"Mississippi","MO":"Missouri","MT":"Montana","NE":"Nebraska","NV":"Nevada","NH":"New Hampshire","NJ":"New Jersey","NM":"New Mexico","NY":"New York","NC":"North Carolina","ND":"North Dakota","OH":"Ohio","OK":"Oklahoma","OR":"Oregon","PA":"Pennsylvania","RI":"Rhode Island","SC":"South Carolina","SD":"South Dakota","TN":"Tennessee","TX":"Texas","UT":"Utah","VT":"Vermont","VA":"Virginia","WA":"Washington","WV":"West Virginia","WI":"Wisconsin","WY":"Wyoming","DC":"District of Columbia"};

function slugify(city, state) {
  return (city + "-" + state).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}

function formatDate(d) {
  if (!d) return "";
  const [y, m, day] = d.split("-");
  const months = ["JANUARY","FEBRUARY","MARCH","APRIL","MAY","JUNE","JULY","AUGUST","SEPTEMBER","OCTOBER","NOVEMBER","DECEMBER"];
  const n = parseInt(day);
  const suffix = (n % 10 === 1 && n !== 11) ? "ST" : (n % 10 === 2 && n !== 12) ? "ND" : (n % 10 === 3 && n !== 13) ? "RD" : "TH";
  return months[parseInt(m)-1] + " " + n + suffix;
}

function formatTime(t) {
  if (!t) return "";
  const [h, m] = t.split(":");
  const hr = parseInt(h);
  return (hr > 12 ? hr - 12 : hr || 12) + (m !== "00" ? ":"+m : "") + (hr >= 12 ? " PM" : " AM");
}

export default function App() {

  const [data, setData] = useState(null);
  const [ahData, setAhData] = useState(null);
  const [path, setPath] = useState(window.location.pathname);
  const [adminOpen, setAdminOpen] = useState(window.location.pathname === '/manage');
  const [loggedIn, setLoggedIn] = useState(false);
  const [userIP, setUserIP] = useState("");

  useEffect(() => {
    fetch("https://americanherdcattleco.com/api/data").then(r => r.json()).then(d => setData(d)).catch(() => {});
    fetch("/api/ah-data").then(r => r.json()).then(d => setAhData(d)).catch(() => setAhData({ locations: [] }));
    fetch("https://api.ipify.org?format=json").then(r => r.json()).then(d => {
      setUserIP(d.ip);
      if (TRUSTED_IPS.includes(d.ip)) setLoggedIn(true);
    }).catch(() => {});
    window.addEventListener("popstate", () => setPath(window.location.pathname));
  }, []);

  const navigate = (p) => { window.history.pushState({}, "", p); setPath(p); };

  if (!data) return <div style={{display:"flex",alignItems:"center",justifyContent:"center",height:"100vh",color:"rgba(26,26,26,.4)",fontSize:".9rem"}}>Loading...</div>;

  const mergedLocations = data.locations.map(loc => {
    const extra = (ahData?.locations || []).find(a => a.id === loc.id) || {};
    return { ...loc, adImage: extra.adImage || null, salePhoto: extra.salePhoto || null };
  });

  const slug = path.replace(/^\//, "");
  const matchedLocation = slug ? mergedLocations.find(l => slugify(l.city, l.state) === slug) : null;

  if (matchedLocation) return <SalePage loc={matchedLocation} navigate={navigate} />;

  return (
    <>
      <Header navigate={navigate} />
      <HomePage locations={mergedLocations} navigate={navigate} />
      {adminOpen && <AdminPanel loggedIn={loggedIn} setLoggedIn={setLoggedIn} onClose={() => setAdminOpen(false)} locations={mergedLocations} ahData={ahData} setAhData={setAhData} />}
    </>
  );
}

function Header({ navigate }) {
  return (
    <header style={{position:"fixed",top:0,left:0,right:0,zIndex:100,background:"rgba(10,10,10,.95)",backdropFilter:"blur(12px)",borderBottom:"1px solid rgba(0,0,0,.06)",padding:"0 2rem",height:60,display:"flex",alignItems:"center"}}>
      <div onClick={() => navigate("/")} style={{cursor:"pointer",display:"flex",alignItems:"center",gap:"10px"}}>
        <div style={{width:32,height:32,background:"#c8102e",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1rem"}}>🐂</div>
        <span style={{fontWeight:700,fontSize:"1.05rem",letterSpacing:".04em",color:"#1a1a1a"}}>AMERICAN HERD</span>
      </div>

    </header>
  );
}

function HomePage({ locations, navigate }) {
  const active = locations.filter(l => !l.soldOut);
  return (
    <main style={{paddingTop:80,minHeight:"100vh"}}>
      <section style={{textAlign:"center",padding:"4rem 2rem 3rem"}}>
        <div style={{fontSize:".72rem",letterSpacing:".2em",textTransform:"uppercase",color:"#c8102e",marginBottom:"1rem",fontWeight:600}}>Truckload Sale Events</div>
        <h1 style={{fontSize:"clamp(2rem,5vw,3.5rem)",fontWeight:800,lineHeight:1.1,marginBottom:"1rem",letterSpacing:"-.02em"}}>
          Premium Beef, Direct<br/><span style={{color:"#c8102e"}}>To Your Community</span>
        </h1>
        <p style={{color:"rgba(26,26,26,.5)",fontSize:"1rem",maxWidth:480,margin:"0 auto",lineHeight:1.7}}>USDA Choice & Prime cuts at truckload prices. Find a sale near you.</p>
      </section>

      <section style={{maxWidth:1100,margin:"0 auto",padding:"0 1.5rem 5rem"}}>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:"1.25rem"}}>
          {active.map(loc => <LocationCard key={loc.id} loc={loc} navigate={navigate} />)}
        </div>
        {active.length === 0 && <div style={{textAlign:"center",color:"rgba(26,26,26,.3)",padding:"4rem"}}>No active sales — check back soon.</div>}
      </section>
    </main>
  );
}

function LocationCard({ loc, navigate }) {
  const slug = slugify(loc.city, loc.state);
  const [hovered, setHovered] = useState(false);
  return (
    <div onClick={() => navigate("/" + slug)}
      onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}
      style={{cursor:"pointer",background:"#1a1a1a",border:"1px solid rgba(0,0,0,.07)",borderRadius:"10px",overflow:"hidden",transition:"transform .2s,box-shadow .2s",transform:hovered?"translateY(-4px)":"none",boxShadow:hovered?"0 16px 40px rgba(0,0,0,.5)":"0 2px 8px rgba(0,0,0,.3)"}}>
      <div style={{height:280,background:"#f7f7f7",overflow:"hidden",position:"relative"}}>
        {loc.adImage && <img src={"https://americanherdcattleco.com" + loc.adImage} alt="" style={{width:"100%",height:"100%",objectFit:"cover",opacity:.9}}/>}
        {!loc.adImage && loc.storeImage && <img src={"https://americanherdcattleco.com" + loc.storeImage} alt="" style={{width:"100%",height:"100%",objectFit:"cover",opacity:.7}}/>}
        {!loc.adImage && !loc.storeImage && <div style={{width:"100%",height:"100%",display:"flex",alignItems:"center",justifyContent:"center",fontSize:"2.5rem"}}>🐂</div>}
        <div style={{position:"absolute",top:10,right:10,background:"#c8102e",color:"#fff",fontSize:".65rem",fontWeight:700,letterSpacing:".1em",padding:".25rem .6rem",borderRadius:"3px",textTransform:"uppercase"}}>On Now</div>
      </div>
      <div style={{padding:"1.1rem 1.25rem"}}>
        <div style={{fontWeight:700,fontSize:"1.1rem",marginBottom:".3rem"}}>{loc.city}, {loc.state}</div>
        <div style={{fontSize:".78rem",color:"rgba(26,26,26,.45)",marginBottom:".5rem"}}>{loc.address}</div>
        <div style={{fontSize:".75rem",color:"#c8102e",fontWeight:600}}>{formatDate(loc.startDate)}{loc.endDate !== loc.startDate ? " – " + formatDate(loc.endDate) : ""} · {formatTime(loc.startTime)} – {formatTime(loc.endTime)}</div>
      </div>
    </div>
  );
}

let _visitorIp = '';
fetch('/api/my-ip').then(r=>r.json()).then(d=>{_visitorIp=d.ip||'';}).catch(()=>{});

function getFbc() {
  try {
    const match = document.cookie.match(/(?:^|;\s*)_fbc=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  } catch(e) { return ''; }
}

function getFbp() {
  try {
    const match = document.cookie.match(/(?:^|;\s*)_fbp=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : '';
  } catch(e) { return ''; }
}

function getExternalId() {
  try {
    let id = localStorage.getItem('ah_ext_id');
    if (!id) {
      id = 'ext_' + Date.now().toString(36) + '_' + Math.random().toString(36).substring(2, 15);
      localStorage.setItem('ah_ext_id', id);
    }
    return id;
  } catch(e) { return ''; }
}

function trackClick(event, loc) {
  const blob = new Blob([JSON.stringify({ event, city: loc.city, state: loc.state, ts: new Date().toISOString(), fbc: getFbc(), fbp: getFbp(), external_id: getExternalId() })], { type: 'application/json' });
  navigator.sendBeacon('/api/ah-click', blob);
}

function SalePage({ loc, navigate }) {
  const mapsUrl = (loc.city === "Cleburne/ Keene")
    ? "https://maps.google.com/?q=32.38182019414786,-97.3374862368943"
    : "https://maps.google.com/?q=" + encodeURIComponent(loc.address);
  const [visible, setVisible] = useState(false);
  const [couponCode] = useState(()=>{const ch="ABCDEFGHJKLMNPQRSTUVWXYZ23456789";let s="";for(let i=0;i<10;i++){if(i===5)s+="-";s+=ch[Math.floor(Math.random()*ch.length)];}return s;});
  const [showMoved, setShowMoved] = useState(!!loc.relocated);
  const [showRelocating, setShowRelocating] = useState(!!loc.relocating);
  const [showJustMoved, setShowJustMoved] = useState(!!loc.justMoved);

  useEffect(() => {
    setTimeout(() => setVisible(true), 50);
    const start = Date.now();
    const slug = window.location.pathname;
    const send = () => {
      const duration = Math.round((Date.now() - start) / 1000);
      if (duration < 2) return;
      const blob = new Blob([JSON.stringify({ path: slug, duration, ts: new Date().toISOString() })], { type: 'application/json' });
      navigator.sendBeacon('/api/ah-session', blob);
    };
    window.addEventListener('beforeunload', send);
    window.addEventListener('pagehide', send);
    return () => {
      window.removeEventListener('beforeunload', send);
      window.removeEventListener('pagehide', send);
    };
  }, []);

  return (
    <div style={{minHeight:"100vh",background:"#ffffff",maxWidth:"100vw",overflowX:"hidden"}}>
      {/* WE HAVE MOVED popup */}
      {showMoved && (
        <div onClick={()=>{ if(!loc.relocatedSlug) setShowMoved(false); }} style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,.88)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1.5rem"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#ffffff",border:"3px solid #c8102e",borderRadius:16,padding:"2.5rem 2rem",maxWidth:480,width:"100%",textAlign:"center",boxShadow:"0 0 60px rgba(200,16,46,.4)"}}>
            <div style={{fontSize:"3rem",marginBottom:".5rem"}}>📍</div>
            <div style={{fontSize:"1.6rem",fontWeight:900,color:"#c8102e",letterSpacing:".05em",marginBottom:"1rem",lineHeight:1.2}}>WE HAVE MOVED!</div>
            <div style={{fontSize:".95rem",color:"rgba(26,26,26,.7)",marginBottom:"1.5rem",lineHeight:1.5}}>
              Our <strong style={{color:"#1a1a1a"}}>{loc.city}, {loc.state}</strong> sale has moved to a new location. See here:
            </div>
            <a href={loc.relocatedSlug ? "/"+loc.relocatedSlug : ("https://maps.google.com/?q="+encodeURIComponent(loc.address))} target={loc.relocatedSlug ? "_self" : "_blank"} rel="noreferrer"
              style={{display:"block",background:"#c8102e",color:"#fff",padding:".85rem",borderRadius:8,fontWeight:700,fontSize:".9rem",textDecoration:"none",marginBottom:".75rem"}}>
              📍 See New Location
            </a>
            {!loc.relocatedSlug && (
            <button onClick={()=>setShowMoved(false)}
              style={{background:"none",border:"1px solid rgba(0,0,0,.15)",color:"rgba(26,26,26,.5)",padding:".6rem 1.5rem",borderRadius:8,cursor:"pointer",fontSize:".8rem",width:"100%"}}>
              Continue to Page
            </button>
            )}
          </div>
        </div>
      )}
      {/* RELOCATING NOTICE popup — informational only, no redirect */}
      {showRelocating && (
        <div onClick={()=>setShowRelocating(false)} style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,.88)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1.5rem"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#ffffff",border:"3px solid #c8102e",borderRadius:16,padding:"2.5rem 2rem",maxWidth:480,width:"100%",textAlign:"center",boxShadow:"0 0 60px rgba(200,16,46,.4)"}}>
            <div style={{fontSize:"3rem",marginBottom:".5rem"}}>🚧</div>
            <div style={{fontSize:"1.6rem",fontWeight:900,color:"#c8102e",letterSpacing:".05em",marginBottom:"1rem",lineHeight:1.2}}>WE'RE RELOCATING!</div>
            <div style={{fontSize:".95rem",color:"rgba(26,26,26,.7)",marginBottom:"1.5rem",lineHeight:1.5}}>
              Our <strong style={{color:"#1a1a1a"}}>{loc.city}, {loc.state}</strong> sale is currently relocating. We'll post the updated sale site here soon — check back shortly!
            </div>
            <button onClick={()=>setShowRelocating(false)}
              style={{background:"#c8102e",color:"#fff",border:"none",padding:".85rem 1.5rem",borderRadius:8,cursor:"pointer",fontWeight:700,fontSize:".9rem",width:"100%"}}>
              Continue to Page
            </button>
          </div>
        </div>
      )}
      {/* JUST MOVED notice popup — page already shows correct new info, this just alerts repeat visitors */}
      {showJustMoved && (
        <div onClick={()=>setShowJustMoved(false)} style={{position:"fixed",inset:0,zIndex:9999,background:"rgba(0,0,0,.88)",display:"flex",alignItems:"center",justifyContent:"center",padding:"1.5rem"}}>
          <div onClick={e=>e.stopPropagation()} style={{background:"#ffffff",border:"3px solid #c8102e",borderRadius:16,padding:"2.5rem 2rem",maxWidth:480,width:"100%",textAlign:"center",boxShadow:"0 0 60px rgba(200,16,46,.4)"}}>
            <div style={{fontSize:"3rem",marginBottom:".5rem"}}>📍</div>
            <div style={{fontSize:"1.6rem",fontWeight:900,color:"#c8102e",letterSpacing:".05em",marginBottom:"1rem",lineHeight:1.2}}>WE'VE MOVED!</div>
            <div style={{fontSize:".95rem",color:"rgba(26,26,26,.7)",marginBottom:"1.5rem",lineHeight:1.5}}>
              Our <strong style={{color:"#1a1a1a"}}>{loc.city}, {loc.state}</strong> sale has a new location and updated details — everything below is current.
            </div>
            <button onClick={()=>setShowJustMoved(false)}
              style={{background:"#c8102e",color:"#fff",border:"none",padding:".85rem 1.5rem",borderRadius:8,cursor:"pointer",fontWeight:700,fontSize:".9rem",width:"100%"}}>
              Got It
            </button>
          </div>
        </div>
      )}
      {/* Back nav */}
      <div style={{position:"fixed",top:0,left:0,right:0,zIndex:100,background:"rgba(10,10,10,.9)",backdropFilter:"blur(10px)",borderBottom:"1px solid rgba(0,0,0,.06)",padding:"0 1.25rem",height:48,display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <button onClick={() => navigate("/")} style={{background:"none",border:"none",color:"rgba(26,26,26,.6)",cursor:"pointer",fontSize:".85rem",display:"flex",alignItems:"center",gap:6,padding:0}}>
          <span style={{fontSize:"1.1rem"}}>←</span> All Sales
        </button>
        <a href="#coupon" onClick={()=>trackClick('coupon_click',loc)} style={{background:"#c8102e",color:"#fff",padding:".4rem .9rem",borderRadius:6,fontWeight:700,fontSize:".75rem",textDecoration:"none",whiteSpace:"nowrap"}}>GET 50% OFF COUPON</a>
      </div>

      <div style={{paddingTop:48}}>
        <div style={{maxWidth:480,margin:"0 auto"}}>
        {/* AD IMAGE — vertical 921x1080, full width */}
        {loc.adImage ? (
          <div style={{width:"100%",position:"relative",background:"#ffffff",opacity:visible?1:0,transition:"opacity .4s"}}>
            <img src={"https://americanherdcattleco.com" + loc.adImage} alt="Sale"
              style={{width:"100%",display:"block",objectFit:"contain",objectPosition:"center"}}/>
          </div>
        ) : (
          <div style={{width:"100%",aspectRatio:"921/1080",background:"linear-gradient(160deg,#fff5f5,#c8102e 50%,#ffffff)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",opacity:visible?1:0,transition:"opacity .4s"}}>
            <div style={{fontSize:"5rem",marginBottom:"1rem"}}>🐂</div>
            <div style={{fontWeight:800,fontSize:"2rem",color:"#fff",letterSpacing:"-.02em",textShadow:"0 2px 12px rgba(0,0,0,.35)"}}>AMERICAN HERD</div>
            <div style={{fontSize:"1rem",color:"rgba(0,0,0,.6)",marginTop:".5rem"}}>{loc.city}, {STATE_NAMES[loc.state]||loc.state}</div>
          </div>
        )}

        {/* ACTION BUTTONS */}
        <div style={{padding:"1.25rem 1.25rem .75rem",maxWidth:560,margin:"0 auto",opacity:visible?1:0,transform:visible?"none":"translateY(12px)",transition:"opacity .4s .1s,transform .4s .1s"}}>
          <div style={{display:"flex",flexDirection:"column",gap:".75rem"}}>
            <a href={mapsUrl} target="_blank" rel="noopener noreferrer"
              onClick={()=>trackClick('directions',loc)} style={{display:"block",background:"#c8102e",color:"#fff",textAlign:"center",padding:"1.1rem",borderRadius:10,fontWeight:900,fontSize:"1.15rem",textDecoration:"none",letterSpacing:".06em",textTransform:"uppercase",textShadow:"0 1px 3px rgba(0,0,0,.4)"}}>
              CLICK HERE TO GET DIRECTIONS
            </a>
            <div style={{textAlign:"center",fontSize:".7rem",fontWeight:800,letterSpacing:".1em",textTransform:"uppercase",color:"#1a1a1a",marginBottom:".3rem"}}>Set a Reminder ↓</div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".75rem"}}>
              <a href={(() => {
                const start = loc.startDate.replace(/-/g,'') + 'T' + (loc.startTime||'09:00').replace(':','') + '00';
                const end = loc.endDate.replace(/-/g,'') + 'T' + (loc.endTime||'19:00').replace(':','') + '00';
                const title = encodeURIComponent('American Herd Sale - ' + loc.city + ', ' + loc.state);
                const details = encodeURIComponent('20 Ribeyes $39 + Deals on Steak, Chicken, Seafood & More!');
                const location = encodeURIComponent(loc.address);
                return 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + title + '&dates=' + start + '/' + end + '&details=' + details + '&location=' + location;
              })()} target="_blank" rel="noopener noreferrer"
                onClick={()=>trackClick('google_calendar',loc)} style={{display:"block",background:"rgba(0,0,0,.04)",color:"#1a1a1a",border:"1.5px solid rgba(0,0,0,.12)",textAlign:"center",padding:".65rem",borderRadius:8,fontWeight:700,fontSize:".8rem",textDecoration:"none",letterSpacing:".02em"}}>
                <span style={{display:"flex",alignItems:"center",justifyContent:"center",gap:".4rem"}}>
                  <svg width="16" height="16" viewBox="0 0 48 48"><rect x="6" y="8" width="36" height="34" rx="4" fill="#fff" stroke="#e0e0e0" strokeWidth="1"/><rect x="6" y="8" width="36" height="9" rx="4" fill="#4285F4"/><rect x="6" y="13" width="36" height="4" fill="#4285F4"/><text x="24" y="34" textAnchor="middle" fontSize="16" fontWeight="700" fill="#EA4335" fontFamily="Arial">G</text><circle cx="15" cy="8" r="2" fill="#fff"/><circle cx="33" cy="8" r="2" fill="#fff"/></svg>
                  Google Calendar
                </span>
              </a>
              <a href={(() => {
                const fmt = (d,t) => { const [y,m,day]=d.split('-'); const [h,min]=(t||'09:00').split(':'); return y+m+day+'T'+h+min+'00'; };
                const ics = ['BEGIN:VCALENDAR','VERSION:2.0','BEGIN:VEVENT',
                  'DTSTART:'+fmt(loc.startDate,loc.startTime),
                  'DTEND:'+fmt(loc.endDate,loc.endTime),
                  'SUMMARY:American Herd Sale - '+loc.city+', '+loc.state,
                  'DESCRIPTION:20 Ribeyes $39 + Deals on Steak, Chicken, Seafood & More!',
                  'LOCATION:'+loc.address,
                  'END:VEVENT','END:VCALENDAR'].join('\n');
                return 'data:text/calendar;charset=utf8,' + encodeURIComponent(ics);
              })()}
                download={"american-herd-"+loc.city.toLowerCase()+".ics"}
                onClick={()=>trackClick('apple_calendar',loc)} style={{display:"block",background:"rgba(0,0,0,.04)",color:"#1a1a1a",textAlign:"center",padding:".65rem",borderRadius:8,fontWeight:700,fontSize:".8rem",textDecoration:"none",border:"1.5px solid rgba(0,0,0,.12)",letterSpacing:".02em"}}>
                <span style={{display:"flex",alignItems:"center",justifyContent:"center",gap:".4rem"}}>
                  <svg width="16" height="16" viewBox="0 0 48 48"><rect x="6" y="8" width="36" height="34" rx="4" fill="#fff" stroke="#e0e0e0" strokeWidth="1"/><rect x="6" y="8" width="36" height="9" rx="4" fill="#333"/><rect x="6" y="13" width="36" height="4" fill="#333"/><circle cx="15" cy="8" r="2" fill="#fff"/><circle cx="33" cy="8" r="2" fill="#fff"/><g transform="translate(17,20) scale(0.018)"><path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 462.3 1 317.8 1 179.8c0-203.9 133.4-312.1 264.8-312.1 70 0 128.3 46.4 171.8 46.4 41.8 0 107.2-49.2 185.6-49.2 29.4 0 133.4 2.6 198.3 99.2zm-234-181.5c31.1-36.9 53.1-88.1 53.1-139.3 0-7.1-.6-14.3-1.9-20.1-50.6 1.9-110.8 33.7-147.1 75.8-28.5 32.4-55.1 83.6-55.1 135.5 0 7.8 1.3 15.6 1.9 18.1 3.2.6 8.4 1.3 13.6 1.3 45.4 0 102.5-30.4 135.5-71.3z" fill="#1a1a1a"/></g></svg>
                  Apple Calendar
                </span>
              </a>
            </div>

          </div>
        </div>

        {/* MORE INFO — expandable */}
        <div style={{maxWidth:560,margin:"0 auto"}}>
          <div style={{padding:"0 1.25rem 3rem"}}>

            {/* Date/Time/Location */}
            <div style={{textAlign:"center",fontSize:".85rem",fontWeight:900,letterSpacing:".08em",textTransform:"uppercase",color:"#c8102e",marginBottom:".5rem"}}>
              {(() => { const days = Math.round((new Date(loc.endDate) - new Date(loc.startDate)) / 86400000) + 1; return days + (days === 1 ? " DAY ONLY" : " DAYS ONLY"); })()}
            </div>
            <div style={{background:"#f7f7f7",border:"1px solid #e5e5e5",borderRadius:10,padding:"1.25rem",marginBottom:"1rem"}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"1rem",marginBottom:"1rem"}}>
                <div>
                  <div style={{fontSize:".65rem",letterSpacing:".1em",textTransform:"uppercase",color:"#c8102e",fontWeight:800,marginBottom:".35rem"}}>Dates</div>
                  <div style={{fontWeight:800,fontSize:"clamp(.78rem,3.2vw,1.05rem)",color:"#1a1a1a",textTransform:"uppercase",whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{formatDate(loc.startDate)}{loc.endDate!==loc.startDate?" – "+formatDate(loc.endDate):""}</div>
                </div>
                <div>
                  <div style={{fontSize:".65rem",letterSpacing:".1em",textTransform:"uppercase",color:"#555",fontWeight:700,marginBottom:".35rem"}}>Hours</div>
                  <div style={{fontWeight:800,fontSize:"1.05rem",color:"#1a1a1a"}}>{formatTime(loc.startTime)} – {formatTime(loc.endTime)}</div>
                </div>
              </div>
              <div>
                <div style={{fontSize:".65rem",letterSpacing:".1em",textTransform:"uppercase",color:"#c8102e",fontWeight:800,marginBottom:".35rem"}}>Where</div>
                <div style={{fontWeight:800,fontSize:".95rem",marginBottom:".25rem",color:"#8b0000"}}>{loc.store}</div>
                <div style={{fontSize:".9rem",color:"#1a1a1a",fontWeight:700,lineHeight:1.5}}>{loc.address}</div>
              </div>
            </div>

            {/* What We Offer */}
            <div style={{background:"#fff",border:"2px solid #c8102e",borderRadius:10,padding:"1.25rem",marginBottom:"1rem"}}>
              <div style={{fontSize:".95rem",letterSpacing:".1em",textTransform:"uppercase",color:"#c8102e",fontWeight:900,marginBottom:"1.1rem"}}>WHAT WE OFFER</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:".65rem"}}>
                {["20 Ribeyes for $39","T-Bone Box Deals","BOGO Bundle Boxes","Chicken Bundles","Seafood Packs","Premium Pork","¼ ½ Whole Cow","Free Freezer Offer"].map(item=>(
                  <div key={item} style={{display:"flex",alignItems:"center",gap:".45rem",fontSize:".85rem",fontWeight:600,color:"#1a1a1a"}}>
                    <span style={{color:"#16a34a",fontWeight:900,fontSize:"1.1rem"}}>✔</span>{item}
                  </div>
                ))}
              </div>
            </div>

            {/* Discounts + Payment */}
            <div style={{background:"#f7f7f7",border:"1px solid #e5e5e5",borderRadius:10,padding:"1.25rem",marginBottom:"1rem"}}>
              <div style={{fontSize:".7rem",letterSpacing:".12em",textTransform:"uppercase",color:"rgba(26,26,26,.5)",fontWeight:700,marginBottom:".75rem"}}>Discounts & Payment</div>
              <div style={{fontSize:".88rem",color:"#1a1a1a",lineHeight:2,fontWeight:700}}>
                10% OFF — Military, First Responders, Nurses, Teachers, Students, Seniors<br/>
                WE ACCEPT — Cash, Credit, Debit, EBT, CashApp, Venmo, Zelle, Apple Pay
              </div>
            </div>

  
          <div style={{position:"relative",textAlign:"center",marginBottom:"1rem",padding:".9rem 0"}}>
            <div style={{position:"absolute",inset:0,background:"linear-gradient(90deg,#c8102e 0%,#f0f0f0 50%,#0a3161 100%)",borderRadius:8,opacity:.12}}></div>
            <div style={{position:"relative",fontSize:"1rem",letterSpacing:".15em",textTransform:"uppercase",fontWeight:900,background:"linear-gradient(90deg,#c8102e 0%,#0a3161 100%)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text"}}>See Our Team In Action</div>
            <div style={{position:"relative",width:60,height:3,background:"linear-gradient(90deg,#c8102e,#0a3161)",margin:".4rem auto 0",borderRadius:2}}></div>
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"8px",borderRadius:10,overflow:"hidden",marginBottom:"1.5rem"}}>
            {["/uploads/photo1.jpeg","/uploads/photo2.jpg","/uploads/photo3.jpg","/uploads/photo4.jpeg"].map((src,i)=>(
              <div key={i} style={{aspectRatio:"1",overflow:"hidden",borderRadius:8,border:"1px solid #e5e5e5"}}>
                <img src={"https://americanherdcattleco.com"+src} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>
              </div>
            ))}
          </div>
          <CouponImage loc={loc} couponCode={couponCode} />
          <div style={{textAlign:"center",fontSize:".68rem",color:"rgba(26,26,26,.2)",lineHeight:1.8}}>
              All products USDA inspected · Raised & sourced in the USA · 100% All Natural
            </div>
          </div>

          </div>
        </div>
      </div>
    </div>
  );
}



function CouponImage({ loc, couponCode }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    const cv = document.createElement('canvas');
    cv.width = 600; cv.height = 380;
    const x = cv.getContext('2d');
    const exp = loc.endDate ? (()=>{ const [y,m,d]=loc.endDate.split('-'); return ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][parseInt(m)-1]+' '+parseInt(d)+', '+y; })() : '';
    x.fillStyle='#fff'; x.fillRect(0,0,600,380);
    x.fillStyle='#c8102e'; x.fillRect(0,0,600,105);
    x.fillStyle='#fff'; x.textAlign='center';
    x.font='bold 58px Arial'; x.fillText('SAVE 50%',300,65);
    x.font='bold 20px Arial';
    const _dateInfo = loc.startDate ? (()=>{ const [y1,m1,d1]=loc.startDate.split('-'); const [y2,m2,d2]=loc.endDate.split('-'); const mn=['JANUARY','FEBRUARY','MARCH','APRIL','MAY','JUNE','JULY','AUGUST','SEPTEMBER','OCTOBER','NOVEMBER','DECEMBER']; const ord=n=>{const s=['TH','ST','ND','RD'];const v=n%100;return n+(s[(v-20)%10]||s[v]||s[0]);} ; const _days = Math.round((new Date(loc.endDate) - new Date(loc.startDate)) / 86400000) + 1; return { range: mn[parseInt(m1)-1]+' '+ord(parseInt(d1))+' - '+mn[parseInt(m2)-1]+' '+ord(parseInt(d2)), daysLabel: '('+_days+(_days===1?' DAY ONLY)':' DAYS ONLY)') }; })() : { range: 'TODAY', daysLabel: '(ONLY)' };
    x.textAlign='left';
    x.font='bold 20px Arial';
    const _rangeWidth = x.measureText(_dateInfo.range).width;
    const _daysWidth = x.measureText(_dateInfo.daysLabel).width;
    const _totalWidth = _rangeWidth + 8 + _daysWidth;
    const _leftX = 300 - (_totalWidth/2);
    x.fillText(_dateInfo.range, _leftX, 95);
    const _daysX = _leftX + _rangeWidth + 8;
    x.strokeStyle='#000'; x.lineWidth=3; x.strokeText(_dateInfo.daysLabel, _daysX, 95);
    x.fillStyle='#fff9b0'; x.fillText(_dateInfo.daysLabel, _daysX, 95);
    x.textAlign='center';
    x.fillStyle='#444'; x.font='bold 16px Arial'; x.fillText('Present this at the sale and receive',300,135);
    x.fillStyle='#c8102e'; x.font='bold 56px Arial'; x.fillText('50% OFF',300,190);
    x.fillStyle='#1a1a1a'; x.font='bold 20px Arial'; x.fillText('ANY STEAK FAMILY BUNDLE',300,222);
    x.fillStyle='#f5f5f5'; x.beginPath(); x.roundRect(120,228,360,56,6); x.fill();
    x.fillStyle='#777'; x.font='11px Arial'; x.fillText('COUPON CODE',300,246);
    x.fillStyle='#1a1a1a'; x.font='bold 26px monospace'; x.fillText(couponCode,300,272);
    x.fillStyle='#444'; x.font='bold 14px Arial'; x.fillText('Only valid at: '+loc.city+', '+loc.state,300,308);
    x.fillStyle='#c8102e'; x.font='bold 14px Arial'; x.fillText('Expires: '+exp,300,330);
    x.fillStyle='#666'; x.font='11px Arial'; x.fillText('One per customer · Cannot be combined',300,352);
    x.strokeStyle='#1a1a1a'; x.lineWidth=2; x.strokeRect(2,2,596,376);
    setSrc(cv.toDataURL('image/jpeg',0.95));
  }, [couponCode, loc.city, loc.state, loc.endDate]);
  if (!src) return null;
  return (
    <div id="coupon" style={{scrollMarginTop:56,marginBottom:"2rem"}}>
      <img src={src} alt="50% Off Coupon"
        style={{width:'100%',borderRadius:10,display:'block',WebkitTouchCallout:'default'}}
        onContextMenu={()=>{ const b=new Blob([JSON.stringify({event:'coupon_save',city:loc.city,state:loc.state,ts:new Date().toISOString(),ip:_visitorIp,fbc:getFbc(),fbp:getFbp(),external_id:getExternalId()})],{type:'application/json'}); navigator.sendBeacon('/api/ah-click',b); }}
        onTouchEnd={(e)=>{ if(Date.now()-(window._couponTouchStart||0)>500){ const b=new Blob([JSON.stringify({event:'coupon_save',city:loc.city,state:loc.state,ts:new Date().toISOString(),ip:_visitorIp,fbc:getFbc(),fbp:getFbp(),external_id:getExternalId()})],{type:'application/json'}); navigator.sendBeacon('/api/ah-click',b); } }}
        onTouchStart={()=>{ window._couponTouchStart=Date.now(); }}
      />
      <div style={{textAlign:'center',fontSize:'.72rem',color:'rgba(26,26,26,.4)',marginTop:'.5rem'}}>📲 Hold down image to save coupon</div>
    </div>
  );
}

function AdminLogin({ onLogin }) {
  const [pw, setPw] = useState("");
  const [err, setErr] = useState(false);
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.85)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:200}}>
      <div style={{background:"#1a1a1a",border:"1px solid rgba(0,0,0,.1)",borderRadius:10,padding:"2rem",width:320}}>
        <div style={{fontWeight:700,fontSize:"1.1rem",marginBottom:"1.5rem"}}>Admin Access</div>
        <input type="password" value={pw} onChange={e=>{setPw(e.target.value);setErr(false);}} onKeyDown={e=>e.key==="Enter"&&(pw===ADMIN_PASS?onLogin():setErr(true))}
          placeholder="Password" style={{width:"100%",background:"rgba(0,0,0,.05)",border:"1px solid rgba(0,0,0,.1)",borderRadius:4,color:"#1a1a1a",padding:".6rem .8rem",fontSize:".9rem",marginBottom:".75rem"}}/>
        {err && <div style={{color:"#e25555",fontSize:".75rem",marginBottom:".75rem"}}>Incorrect password</div>}
        <button onClick={()=>pw===ADMIN_PASS?onLogin():setErr(true)} style={{width:"100%",background:"#c8102e",color:"#fff",border:"none",borderRadius:4,padding:".75rem",fontWeight:700,cursor:"pointer"}}>Enter</button>
      </div>
    </div>
  );
}

function AdminPanel({ loggedIn, setLoggedIn, onClose, locations, ahData, setAhData }) {
  const [saving, setSaving] = useState(false);
  const [toast, setToast] = useState("");

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(""), 3000); };

  const uploadImage = async (file, locId, field) => {
    const reader = new FileReader();
    return new Promise(res => {
      reader.onload = async e => {
        try {
          const r = await fetch("/api/ah-upload", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({ data: e.target.result, name: file.name.replace(/[^a-z0-9.]/gi,"_"), locId, field }) });
          const j = await r.json();
          res(j.url);
        } catch { res(null); }
      };
      reader.readAsDataURL(file);
    });
  };

  const updateLocField = async (locId, field, url) => {
    const newLocs = [...(ahData?.locations || [])];
    const idx = newLocs.findIndex(l => l.id === locId);
    if (idx >= 0) newLocs[idx] = { ...newLocs[idx], [field]: url };
    else newLocs.push({ id: locId, [field]: url });
    const newData = { ...ahData, locations: newLocs };
    setAhData(newData);
    await fetch("/api/ah-data", { method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify(newData) });
    showToast("Saved!");
  };

  if (!loggedIn) return <AdminLogin onLogin={() => setLoggedIn(true)} />;

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.9)",zIndex:200,overflowY:"auto"}}>
      <div style={{maxWidth:800,margin:"0 auto",padding:"2rem 1.5rem"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"2rem"}}>
          <div style={{fontWeight:800,fontSize:"1.2rem"}}>american-herd.com <span style={{color:"#c8102e"}}>Admin</span></div>
          <button onClick={onClose} style={{background:"none",border:"1px solid rgba(0,0,0,.1)",borderRadius:4,color:"rgba(26,26,26,.5)",padding:".4rem .9rem",cursor:"pointer"}}>✕ Close</button>
        </div>
        {toast && <div style={{background:"rgba(92,184,92,.15)",border:"1px solid rgba(92,184,92,.3)",borderRadius:4,padding:".6rem 1rem",marginBottom:"1rem",fontSize:".82rem",color:"#5cb85c"}}>✓ {toast}</div>}

        <div style={{fontSize:".72rem",letterSpacing:".12em",textTransform:"uppercase",color:"rgba(26,26,26,.35)",marginBottom:"1rem"}}>Sale Location Images — {locations.length} locations</div>
        <div style={{fontSize:".78rem",color:"rgba(26,26,26,.4)",marginBottom:"1.5rem",lineHeight:1.6}}>Upload an <strong style={{color:"#ffc46b"}}>Ad Image</strong> (shown as hero banner on the sale page + card thumbnail) and a <strong style={{color:"#7baee8"}}>Sale Site Photo</strong> (shown on the sale page below the details). These are separate from the main site's location photos.</div>

        {locations.map(loc => {
          const extra = (ahData?.locations || []).find(a => a.id === loc.id) || {};
          return (
            <div key={loc.id} style={{background:"#1a1a1a",border:"1px solid rgba(0,0,0,.07)",borderRadius:8,padding:"1.25rem",marginBottom:"1rem"}}>
              <div style={{fontWeight:700,marginBottom:".25rem"}}>{loc.city}, {loc.state}</div>
              <div style={{fontSize:".75rem",color:"rgba(26,26,26,.4)",marginBottom:"1rem"}}>{loc.address}</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr",gap:"1rem"}}>
                <div>
                  <div style={{fontSize:".68rem",letterSpacing:".1em",textTransform:"uppercase",color:"#ffc46b",marginBottom:".5rem",fontWeight:600}}>Ad Image</div>
                  {extra.adImage && <img src={"https://americanherdcattleco.com" + extra.adImage} alt="" style={{width:"100%",height:100,objectFit:"cover",borderRadius:4,marginBottom:".5rem"}}/>}
                  <div style={{display:"flex",flexDirection:"column",gap:".4rem"}}>
                    <label style={{display:"block",background:"rgba(255,196,107,.08)",border:"1px dashed rgba(255,196,107,.3)",borderRadius:4,padding:".6rem",textAlign:"center",cursor:"pointer",fontSize:".75rem",color:"rgba(255,196,107,.7)"}}>
                      {extra.adImage ? "Replace Ad Image" : "Upload Ad Image"}
                      <input type="file" accept="image/*" style={{display:"none"}} onChange={async e => { const url = await uploadImage(e.target.files[0], loc.id, "adImage"); if(url) await updateLocField(loc.id, "adImage", url); e.target.value=""; }}/>
                    </label>
                    {extra.adImage && <button onClick={()=>updateLocField(loc.id,"adImage",null)} style={{background:"rgba(226,85,85,.1)",border:"1px solid rgba(226,85,85,.3)",borderRadius:4,padding:".4rem",fontSize:".72rem",color:"#e25555",cursor:"pointer"}}>Remove</button>}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
